import { render, staticRenderFns } from "./certifsItemTpl.vue?vue&type=template&id=2fc958c4&scoped=true&lang=html&"
import script from "./certifsItemTpl.vue?vue&type=script&lang=js&"
export * from "./certifsItemTpl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc958c4",
  null
  
)

export default component.exports